// extracted by mini-css-extract-plugin
export default {"formInputBox":"index_formInputBox_8waim","formInput":"index_formInput_F1gug"};